<template>
  <div class="historyPage">
    <div class="toolBar">
      <div class="titleBox">
        <span class="tableTitle">历史数据</span>
      </div>
      <div class="searchBox">
        <!-- <el-autocomplete
          size="small"
          class="inline-input"
          v-model="keyWord"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
          @select="handleSelect"
        ></el-autocomplete>-->
        <el-button type="primary"
                   @click="showFilter"
                   size="small">筛选</el-button>
      </div>
    </div>
    <div class="tableBox">
      <el-table :data="historyTableData"
                border
                :cell-class-name="'cellClass'"
                :stripe="true"
                v-loading="loading">
        <el-table-column v-for="(item, index) in historyTableHead"
                         :key="index"
                         :prop="item.prop"
                         :label="item.label"
                         :width="item.width"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-popconfirm title="这是一段内容确定删除吗？"
                           @confirm="deleteOne(scope.row)">
              <el-button type="danger"
                         size="mini"
                         slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <history-pop v-if="showPop"
                 @save="getTimeType"
                 @close="close">
    </history-pop>
  </div>
</template>

<script>
import { getHistory, deleteHistory } from '../../api/process'
import formatDate from '../../utils/formatDate'
import historyPop from './pop/filterHistory.vue'
export default {
  name: 'history',
  components: { historyPop },
  data() {
    return {
      loading: false,
      model_type: '',
      showPop: false,
      form: {},
      start_date: '2000-01-01',
      end_date: formatDate(new Date().getTime(), 'YYYY-MM-DD'),
      historyTableHead: [
        {
          prop: 'type_name',
          label: '型号'
        },
        {
          prop: 'tc_time',
          label: '投产时间'
        },
        {
          prop: 'rk_time',
          label: '入库时间'
        },
        {
          prop: 'bar_code',
          label: '条形码'
        },

        {
          prop: 'quantity',
          label: '数量'
        }
        
      ],
      historyTableData: [
        //  {
        //      model_type:"TCL-98",
        //      barCode:"44554444444444",
        //      quanlity:"678",
        //      date:"2012-12-12 12:12:09"
        //  },
        //   {
        //      model_type:"TCL-98",
        //      barCode:"44554444444444",
        //      quanlity:"678",
        //      date:"2012-12-12 12:12:09"
        //  },
        //   {
        //      model_type:"TCL-98",
        //      barCode:"44554444444444",
        //      quanlity:"678",
        //      date:"2012-12-12 12:12:09"
        //  },
        //   {
        //      model_type:"TCL-98",
        //      barCode:"44554444444444",
        //      quanlity:"678",
        //      date:"2012-12-12 12:12:09"
        //  }
      ]
    }
  },
  created() {
    this.model_type = this.$route.query.model_type
    this.getHistoryData(this.start_date, this.end_date)
  },
  methods: {
    getHistoryData(start, end) {
      let that = this
      that.loading = true
      getHistory({
        model_type: this.model_type,
        start_date: start,
        end_date: end
      })
        .then((res) => {
          that.historyTableData = res.data
          that.loading = false
        })
        .catch((e) => {
          that.loading = false
        })
    },

    getTimeType(form) {
      // let start_date=""
      // let end_date=""
      // if(form.dateType=="date"){
      //   start_date=form.date
      //   end_date=start_date
      // }else {
      //   start_date=form.date+"-01"
      //   end_date=form.date+"-31"
      // }
      this.getHistoryData(form.start_date, form.end_date)
      this.start_date = form.start_date
      this.end_date = form.end_date
      this.showPop = false

    },
    close() {
      this.showPop = false
    },
    showFilter() {
      this.showPop = true
    },
    deleteOne(row) {
      const data = { product_id: row.product_id }
      deleteHistory(data).then((res) => {
        if (res.success === true) {
          this.$message.success('删除成功！')
          this.getHistoryData(this.start_date, this.end_date)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.historyPage {
  .toolBar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/produceDataManage/history.vue